import { Box, Button, ButtonProps, Center, Container, Grid } from '@chakra-ui/react';
import { ChainType } from '@cyberkongz/config-blockchain';
import { useChainEnhanced } from '@cyberkongz/ui-blockchain';
import { PropsWithChildren, ReactNode } from 'react';

import { useWeb3Context } from '../../hooks';

export function SwitchNetworkButton(props: ButtonProps) {
  const { handleSwitchNetwork } = useWeb3Context();

  return (
    <Button onClick={handleSwitchNetwork} {...props}>
      {props.children || 'Switch Network'}
    </Button>
  );
}
// TO DO REWORK LATER ON MESSAGING
export function WithExpectedChainConnection({
  children,
  expectedChain,
  expectedMessageComponent,
}: PropsWithChildren & {
  expectedChain?: ChainType;
  expectedMessageComponent?: ReactNode;
}) {
  const { chain, switchToChain } = useChainEnhanced();

  return chain && expectedChain ? (
    expectedChain === chain.type ? (
      <>{children}</>
    ) : (
      <>
        {expectedMessageComponent || (
          <Grid gap={8}>
            <Box>Please switch to {switchToChain?.name} Network to proceed</Box>
            <Box textAlign="right">
              <SwitchNetworkButton />
            </Box>
          </Grid>
        )}
      </>
    )
  ) : null;
}

// TO DO SWITCH TO SMTH ELSE IN TERMS OF COMPONENT TREE
export function WithExpectedNetworkConnectionLegacy({
  children,
  expectedNetwork,
}: PropsWithChildren & { expectedNetwork?: ChainType }) {
  const { chain, switchToChain } = useChainEnhanced();

  return chain && expectedNetwork ? (
    expectedNetwork === chain.type ? (
      <>{children}</>
    ) : (
      <Container>
        <Center>
          <Grid gap={4} textAlign="center">
            <Box>Please switch to {switchToChain?.name} Network to proceed</Box>
            <Box>
              <SwitchNetworkButton />
            </Box>
          </Grid>
        </Center>
      </Container>
    )
  ) : null;
}
